import { useEffect, useState, useRef } from 'react';

export const useIsVisible = (
  node: HTMLElement | undefined | null,
  threshold = 1,
  once = false,
) => {
  const everFiredRef = useRef(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!node) {
      return () => {};
    }

    // If was once visible, and should never change since that. Always return.
    if (visible && once) {
      return () => {};
    }

    // @ts-ignore
    const observer = new IntersectionObserver((entries: any) => {
      let newValue = entries[0].isIntersecting;
      if (!newValue && !everFiredRef.current) {
        newValue = undefined;
      }
      if (newValue) {
        everFiredRef.current = true;
      }
      setVisible(newValue);
    }, {
      threshold,
    });
    observer.observe(node);

    return () => observer.unobserve(node);
  }, [node, visible]);

  return visible;
};
